<template>
  <div>
    <div>
      <div class="avatar">
        <avatar
          :user="getCurrentUser"
          :hide-nick-name="true"
          :width="120"
          :height="127"
        />
        <div class="name">
          <h1>
            {{ getCurrentUser.firstName }} {{ getCurrentUser.lastName }}
            <small>(me)</small>
          </h1>
          <!-- <h4>
            <span
              v-for="role in getCurrentUser.type"
              :key="role.id"
              class="badge badge-pill badge-primary"
              >{{ role }}</span
            >
          </h4> -->
          <b-col md="8" class="time-row">
            <TimeRow v-if="user" :user="user" />
          </b-col>
        </div>
      </div>
      <b-row class="ml-1">
        <div class="mr-12">
          <b-dropdown size="sm" variant="outline-primary" :text="state">
            <b-dropdown-item @click="changeState('All')">
              Show All
            </b-dropdown-item>
            <b-dropdown-item @click="changeState('Tickets')">
              Show Just Tickets
            </b-dropdown-item>
            <b-dropdown-item @click="changeState('Tasks')">
              Show Just Tasks
            </b-dropdown-item>
            <b-dropdown-item @click="changeState('Overdue')">
              Show Just Overdue
            </b-dropdown-item>
          </b-dropdown>
        </div>
      </b-row>
      <UserDashboard :user="user" :state="state" />
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex"
import avatar from "@/components/projectAvatar"
import UserDashboard from "@/components/userdashboard"
import TimeRow from "@/components/teammember/userBlock/timeRow"

export default {
  layout: "default",
  name: "Dashboard",
  components: {
    UserDashboard,
    TimeRow,
    avatar
  },
  apollo: {
    user: {
      query: require("@/graphql/Account/GetUserWithTimeLogs.gql"),
      variables() {
        return {
          userId: this.getCurrentUser.id
        }
      },
      skip() {
        return !this.getCurrentUser?.id
      }
    }
  },
  data() {
    return {
      loading: true,
      state: "All"
    }
  },
  computed: {
    ...mapGetters({
      getCurrentUser: "getCurrentUser"
    })
  },

  methods: {
    /**
     * changes page state
     * @param state
     */
    changeState(state) {
      this.state = state
    }
  }
}
</script>
<style scoped>
.avatar {
  margin-bottom: 20px;
}
.avatar .name {
  display: inline-block;
  margin-left: 50px;
}
.avatar h1 {
  margin-bottom: 0px;
  font-size: 40px;
}
.large {
  font-size: 0.8rem;
}

.time-row {
  padding: 0;
  margin: 0 0 0 -5px;
}
</style>
